<template>
  <div class="order-affiliate-table mt-5">
    <b-table
      bordered
      :items="items"
      :fields="fields"
      hover
      responsive
      class="mb-0"
    >
      <template #cell(rewardAffiliateName)="row">
        <div class="font-weight-bold">
          <p
            class="clickable"
            @click="redirectToRewardAffiliate(row.item.rewardAffiliateId)"
          >
            {{ row.item.rewardAffiliateName }}
          </p>
        </div>
      </template>
      <template #cell(commissionRate)="row">
        <span
          class="text-right font-weight-bold"
          v-b-tooltip.hover.left="'Tỷ lệ hoa hồng'"
        >
          {{ row.item.commissionRate }}%
        </span>
      </template>
      <template #cell(productName)="row">
        <div class="font-weight-bold">
          <p class="m-0">{{ row.item.productName }}</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'OrderAffiliateTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'rewardAffiliateName',
          label: 'Tên chương trình',
          thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right font-weight-bold',
        },
        {
          key: 'commissionRate',
          label: 'Tỷ lệ',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          sortable: true,
          tdClass: 'text-right font-weight-bold',
        },
      ],
    };
  },
  methods: {
    redirectToRewardAffiliate(rewardAffiliateId) {
      const routeData = this.$router.resolve({
        name: 'upsert-reward-affiliate',
        query: { id: rewardAffiliateId, action: 'view' },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.order-affiliate-table {
  background: #f7fafd;
}
.clickable:hover {
  cursor: pointer;
  color: #007bff;
  opacity: 0.7;
}
</style>
